export async function dataURLtoFileBlob(path: string, format: string): Promise<File> {
  try {
    const response = await fetch(path);
    const blob = await response.blob();
    return new File([blob], 'file', { type: format });
  } catch (error) {
    throw new Error('[SolutionImageService]: Failed to get file blob from path');
  }
}

export function convertFileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
}

export async function creteImageElement(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
}

export function getFilesFromEvent(event: Event): File[] {
  const fileInput = event.target as HTMLInputElement;

  const files = fileInput?.files;

  const filesArray = Array.from(files ?? []);

  fileInput.value = '';

  return filesArray;
}
